import React from "react";
import { formatReportHtml } from "../../../utils/formatReportHtml";

const FaqDrawer = ({
  open,
  toggle,
  faq,
}: {
  open: boolean;
  toggle: () => void;
  faq: any;
}) => {
  return (
    <>
      {/* Overlay */}
      <div
        onClick={toggle}
        className={`fixed inset-0 bg-black/40 backdrop-blur-sm z-40 transition 
        ${open ? "opacity-100" : "opacity-0 pointer-events-none"}`}
      />

      {/* Drawer */}
      <div
        className={`
          fixed
          right-0
          top-[64px]
          h-[calc(100vh-64px)]
          w-full
          sm:w-[420px]
          lg:w-[520px]
          bg-white
          shadow-[0_30px_60px_rgba(0,0,0,0.15)]
          z-50
          transform transition-transform duration-500
          ${open ? "translate-x-0" : "translate-x-full"}
        `}
      >
        {/* Header */}
        <div className="flex justify-between items-start px-4 sm:px-6 lg:px-10 py-5 sm:py-6 lg:py-8 border-b border-[#eef0f6]">

          <h2 className="text-lg sm:text-xl lg:text-[28px] font-semibold text-[#26295e] leading-tight pr-4">
            {faq?.label}
          </h2>

          <button
            onClick={toggle}
            className="text-[#7b82a8] hover:text-[#26295e] text-xl sm:text-2xl"
          >
            ✕
          </button>

        </div>

        {/* Content */}
        <div className="h-full overflow-y-auto px-4 sm:px-6 lg:px-10 py-6 sm:py-8 pb-20 sm:pb-24 lg:pb-28">

          <div
            className="
              text-sm sm:text-base lg:text-[17px]
              leading-7 sm:leading-8
              text-[#4b507d]
              space-y-4
            "
            dangerouslySetInnerHTML={{
              __html: formatReportHtml(faq?.content || ""),
            }}
          />

        </div>
      </div>
    </>
  );
};

export default FaqDrawer;